import React, { Fragment } from "react";

const TabPanel = ({ children, active, index }) => (
    <Fragment>
      {active === index && (children)}
    </Fragment>
);

export default TabPanel;
